var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendCustomization(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7896_71358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.68379 14.4452C9.70911 14.5083 9.75311 14.5622 9.80989 14.5995C9.86668 14.6369 9.93353 14.6559 10.0015 14.6542C10.0694 14.6525 10.1352 14.63 10.19 14.5898C10.2448 14.5496 10.286 14.4935 10.3081 14.4293L14.6386 1.77083C14.6599 1.7118 14.664 1.64792 14.6503 1.58666C14.6366 1.5254 14.6058 1.46929 14.5614 1.42491C14.517 1.38053 14.4609 1.34971 14.3997 1.33605C14.3384 1.32239 14.2745 1.32646 14.2155 1.34778L1.55709 5.67829C1.49279 5.70034 1.43678 5.74153 1.39657 5.79633C1.35636 5.85113 1.33388 5.91692 1.33214 5.98486C1.3304 6.05281 1.34949 6.11966 1.38684 6.17645C1.42419 6.23324 1.47802 6.27724 1.5411 6.30255L6.82432 8.42117C6.99134 8.48804 7.14308 8.58803 7.27041 8.71513C7.39774 8.84223 7.49801 8.99379 7.56517 9.16069L9.68379 14.4452Z",
    stroke: "white",
    strokeWidth: 1.33247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5601 1.42969L7.27148 8.71761",
    stroke: "white",
    strokeWidth: 1.33247,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7896_71358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9896,
    height: 15.9896,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendCustomization);
export default __webpack_public_path__ + "static/media/send-customization.befdc3d75aaa099b1b66849ebdf76240.svg";
export { ForwardRef as ReactComponent };